export const startTitles = ['Product', 'Masters', 'Singles', 'Total'];

export const endTitles = [
  'Product',
  'Masters',
  'Singles',
  'Demos',
  'Damaged',
  'Total',
];

export const getTemplateAndHeaders = (isHideCostPrice: boolean) => {
  let template = 'repeat(5, 1fr)';
  let headers = [
    'Product',
    'Revenue',
    'Quantity',
    'Cost Price',
    'Total Stock Cost',
  ];

  if (isHideCostPrice) {
    template = 'repeat(4, 1fr)';
    headers = ['Product', 'Revenue', 'Quantity', 'Total Stock Cost'];
  }

  return { headers, template };
};
